import React from 'react';
import { C } from '../../shared/design-tokens.js';

export const CONTROL_INPUT: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  borderRadius: 8,
  border: `1px solid ${C.borderSoft}`,
  background: 'rgba(7, 11, 18, 0.72)',
  color: C.text,
  fontSize: 14,
  boxSizing: 'border-box',
};

export const MUTED_LABEL: React.CSSProperties = {
  display: 'block',
  color: C.textMuted,
  fontSize: 12,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  marginBottom: 6,
};

export const FREQUENCY_OPTIONS = ['Just once', 'A few times', 'Every time'];

export const PAGE_OPTIONS = [
  'Dashboard / ops',
  'Daily Entry',
  'Directory',
  'Scheduler',
  'Fleet',
  'Finance',
  'Scorecard',
  'Safety meetings',
  'Onboarding',
  'Bug Trap',
  'Permissions',
  'Settings',
  'Other',
];

export function issueStatusPresentation(status: string) {
  switch (status) {
    case 'open':         return { label: 'Open',         color: C.red,      background: 'rgba(255,107,107,0.12)' };
    case 'acknowledged': return { label: 'Acknowledged', color: C.gold,     background: 'rgba(201,162,39,0.12)' };
    case 'fixed':        return { label: 'Fixed',        color: C.green,    background: 'rgba(78,205,196,0.12)' };
    case 'wont_fix':     return { label: "Won't fix",    color: C.textMuted, background: 'rgba(255,255,255,0.05)' };
    default:             return { label: status || 'Unknown', color: C.textMuted, background: 'rgba(255,255,255,0.05)' };
  }
}
